import classNames from 'classnames'
import type * as React from 'react'

import useEventIdCallback from '../../../../../hooks/useEventIdCallback'

import styles from './LogMessageFocusWrapper.css'

type Props = {
  id: number
  index: number
  style?: React.CSSProperties
  className?: string | null | undefined
  children: React.ReactNode
  onKeyDown: (event: React.KeyboardEvent, index: number) => unknown
  onClick: (event: React.MouseEvent, id: number) => unknown
  level: number
  expanded?: boolean
}
export default function LogMessageFocusWrapper({
  style,
  index,
  id,
  children,
  className,
  level,
  expanded,
  onKeyDown,
  onClick,
}: Props) {
  const onKeyDownCallback = useEventIdCallback<React.KeyboardEvent, number>(onKeyDown, index)
  const onClickCallback = useEventIdCallback<React.MouseEvent, number>(onClick, id)
  return (
    <div
      className={classNames(styles.wrapper, className)}
      tabIndex={0}
      role="row"
      aria-level={level}
      aria-expanded={expanded}
      data-id={id}
      data-log-row
      style={style}
      onKeyDown={onKeyDownCallback}
      onClick={onClickCallback}
    >
      {children}
    </div>
  )
}
